import { find, isFunction, remove } from 'lodash-es'
import { v4 as uuidv4 } from 'uuid'

export default {
  state: {
    subproducts: {},
  },
  mutations: {
    SET_SUBPRODUCTS(state, payload) {
      state.subproducts = payload
    },
    ADD_SUBPRODUCT(state, { productId, ...payload }) {
      const products = { ...state.products }
      const subproducts = { ...state.subproducts }
      const product = products[productId]

      if (product) {
        const id = payload.id || uuidv4()
        subproducts[id] = {
          ...payload,
        }
        product.subproducts = [...(product.subproducts || []), id]
        state.products = products
        state.subproducts = subproducts
      }
    },
    REMOVE_SUBPRODUCT(state, { id }) {
      const products = { ...state.products }
      const subproducts = state.subproducts
      const product = products[subproducts[id]?.product]
      if (product) {
        remove(product.subproducts, (item) => item === id)
        state.products = products
      }
    },
    UPDATE_SUBPRODUCT(state, { id, payload }) {
      const subproduct = state.subproducts[id]
      if (subproduct) {
        if (isFunction(payload)) {
          state.subproducts[id] = payload(subproduct)
        } else {
          state.subproducts[id] = {
            ...subproduct,
            ...payload,
          }
        }
      }
    },
  },
  getters: {
    getSubproducts: (state) => (categoryId, productId) => {
      const category = find(state.rtb.categories, { id: categoryId })
      const product = find(category?.products, { id: productId })
      return product?.subproducts || []
    },
  },
}
